<div id="icon-menubar">
  <i class="fa fa-subject icon-menu" theme (click)="toggleMenu()"></i>
</div>
